import { render, staticRenderFns } from "./editRTFComm.vue?vue&type=template&id=503cd382&lang=pug&"
import script from "./editRTFComm.vue?vue&type=script&lang=js&"
export * from "./editRTFComm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports